import { render } from "./InvoiceForm.vue?vue&type=template&id=42f2b2a7"
import script from "./InvoiceForm.vue?vue&type=script&lang=js"
export * from "./InvoiceForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__